import { createFileRoute } from '@tanstack/react-router';

import { ReportingPage, reportingSearchSchema } from '@/pages/reporting';

export const Route = createFileRoute('/reporting')({
    validateSearch: reportingSearchSchema,
    component: ReportingPage,
});
